// 入場權限相關 API（使用 qaRequest，帶 Bearer Token）
import qaRequest from '../core/qaRequest';

/**
 * 確認使用者是否具備問答區的入場權限（GET /v1/entry/）
 * @returns {Promise<MessageResponse>}
 * @see {@link ../core/types.js} MessageResponse
 */
const apiGetEntryPermission = () => qaRequest.get('/v1/entry/');

export default {
  apiGetEntryPermission,
};
